module.exports = __webpack_public_path__ + "media/images/logos/twitter-bcc88b75038e2efab5e8f54df23c2361.svg";